import { render } from "./MasterDataTranslationsView.vue?vue&type=template&id=39aba63c&scoped=true&ts=true"
import script from "./MasterDataTranslationsView.vue?vue&type=script&lang=ts"
export * from "./MasterDataTranslationsView.vue?vue&type=script&lang=ts"

import "./MasterDataTranslationsView.vue?vue&type=style&index=0&id=39aba63c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39aba63c"]])

export default __exports__